import React from 'react';
import { motion } from 'framer-motion';
import { TruckIcon, WrenchIcon, PackageIcon } from 'lucide-react';
const services = [{
  icon: TruckIcon,
  title: 'Ready-to-Drive Campervans',
  description: 'We source, convert, and sell fully finished PV5 campervans. Browse our current stock or let us build your specification from the ground up.',
  image: 'https://cdn.magicpatterns.com/uploads/qFW89RcyBX33659yxzv9re/WhatsApp_Image_2026-03-31_at_11.50.19_PM_(4).jpg',
  alt: 'Kia PV5 front three-quarter view in showroom, ready to drive'
}, {
  icon: WrenchIcon,
  title: 'Customer Vehicle Conversions',
  description: 'Already own a PV5? Bring it to us. Our skilled engineers will transform your vehicle using premium components and meticulous attention to detail.',
  image: 'https://cdn.magicpatterns.com/uploads/4HRWepTXbeHf8NKYokH8V6/WhatsApp_Image_2026-04-03_at_12.38.52_AM_(1).jpg',
  alt: 'Kia PV5 rear doors open with pop-top raised during conversion in workshop'
}, {
  icon: PackageIcon,
  title: 'Accessories & Leisure Living',
  description: 'From practical essentials to comfort upgrades, we supply accessories for every aspect of campervan and leisure living—all carefully selected to meet our exacting standards.',
  image: 'https://cdn.magicpatterns.com/uploads/8UKWBHnS8377PWr1NkNUJZ/WhatsApp_Image_2026-03-31_at_11.50.21_PM_(1).jpg',
  alt: 'Kia PV5 side profile with sliding door open in showroom'
}];
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      delay: i * 0.15,
      ease: 'easeOut'
    }
  })
};
export function ServicesSection() {
  return <section id="services" className="relative w-full bg-dark-900 py-24 md:py-32" data-id="element-157">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="text-center mb-16" data-id="element-159">
          <p className="text-gold text-sm font-semibold tracking-[0.3em] uppercase mb-4 font-body" data-id="element-160">
            Our Services
          </p>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold" data-id="element-161">
            Every Configuration. Every Need.{' '}
            <span className="text-gold italic" data-id="element-162">Covered.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-163">
          {services.map((service, i) => <motion.div key={service.title} custom={i} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={cardVariants} className="group relative bg-dark-700/50 border border-white/5 rounded-xl overflow-hidden hover:border-gold/30 transition-all duration-500 hover:bg-dark-700/80" data-id="element-164">
              <div className="aspect-[16/10] overflow-hidden" data-id="element-165">
                <img src={service.image} alt={service.alt} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-166" />
              </div>
              <div className="p-8" data-id="element-167">
                <div className="w-12 h-12 rounded-lg bg-gold/10 flex items-center justify-center mb-5 group-hover:bg-gold/20 transition-colors duration-500" data-id="element-168">
                  <service.icon className="text-gold" size={22} data-id="element-169" />
                </div>
                <h3 className="font-display text-xl font-semibold mb-4" data-id="element-170">
                  {service.title}
                </h3>
                <p className="text-white/50 text-sm leading-relaxed font-body" data-id="element-171">
                  {service.description}
                </p>
              </div>
              <div className="absolute bottom-0 left-8 right-8 h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-172" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}